import { defineNuxtPlugin, useAuthStore } from '#imports'

export default defineNuxtPlugin(() => {
  const authStore = useAuthStore()

  // Initialize auth state before any components render
  authStore.initializeAuth()
})
